export default {
  common: {
    require: '{0} is required',
    requires: '{0} are required',
    typeRequire: '{0} must be selected.',
    saveSuccess: '{0} has been saved successfully.',
    deleteConfirm: 'Do you really want to delete the selected items?',
    fromDateValidate: 'Invalid From Date. Please Enter the date within 180 days from today’s date.',
    searchConditionValidate: 'Process ID is required when searching without date condition.',
    noSelectItem: 'There is no selected item.',
    validateDate: 'Invalid date or time',
    contentAllowPopup: 'Please help us check and add our site to allow popup on browser.',
    lableAllowPopup: 'Do not open pop-up again.',
    applyDateCond: 'Apply Date Condition',
    deploySuccess: '{0} has been deployed successfully.',
    info: {},
    infoConfirm: {
      title: 'Information',
      detail: 'Are you sure you would like to {0}?',
      duplicate: 'Same filename is exist. Would you like to overwrite as same filename?',
    },
    success: {
      title: 'Success',
      detail: '{0} has been {1} successfully.',
      copy: 'Copy path done !',
    },
    warning: {
      title: 'Warning',
      detail: '',
      detailWarningDuplicationCheckOut: 'This mapper has already been checked out',
      // detailOkConfirm: 'Click "OK" to lock the file for editing. During the check in process, you can release the lock. Click "Cancel" to check out a read-only copy of the file.',
      detailOkConfirm:
        'Click "OK" to lock the file for re-upload. During the check in process, you can release the lock. Click "Cancel" to just download the layout file.',
      detailWarningCheckIn: "Cannot check in, you don't own a lock on the file.",
      compileDownload: 'You can downlaod compiled mapper or scanner file!',
      notFindTargetFile: 'Cannot find target file in system!',
      moveConfirm: 'Would you like to open the {0} on Map Builder',
      detailWarningIsCheckedOut: `You can't Check In/Check Out because this {0} is locked by "{1}".`,
      detailWarningReleaseLocked: `You can't Release Locked {2} because this {0} is locked by "{1}".`,
    },
    error: {
      tittle: 'Error',
      detail: '',
    },
  },
  mapBuilder: {
    noSuccessCheckIn: 'There is no success execute history.',
    compileWarning: 'Before compile it , Please save it!',
    executeWarning: 'Please save the input file first to execute.',
    confirmCheckOut:
      'Would you like to check out for redeploy? \nChecking out will lock the file to prevent others from making changes.',
    loadFile: {
      noSelectItem: 'Please select the file you want to delete.',
      noSelectFolder: 'Please select the folder you want to delete.',
      clickIconDelete: 'Please select the file you want to delete.',
      warningOpen: 'Please select one file to open',
      selectFolder: 'Please select folder',
      noInputFileName: 'Please input file name',
      addSuccess: 'Added Successful!',
      confirmInputFile:
        'File Name is required and cannot have spaces, special characters except hyphen,underbar,parentheses or dot',
      copyInfomation: 'Please choose folder copy file to.',
      moveInfomation: 'Please choose folder move file to.',
      warningExistFileMove: 'The file exists in this folder.',
      warningEditFileName: 'Would you like to rename another file?',
      warningEmptyFileName: "The file name shouldn't be empty.",
      warningEmptyFolderName: "The folder name shouldn't be empty.",
    },
    versionHistory: {
      warningCheckIn: "Cannot check in, you don't own a lock on the file.",
      okConfirm: `Click "OK" to lock the file for editing. During the check in process, you can release the lock. Click "Cancel" to just load the {0} file.`,
      warningDownload: 'File does not exist',
    },
    addLabelHtml:
      '<div class="col-lg-6 col-md-6 col-12 pa-0 pl-1">\
                    <span class="file-name-expand">{title}</span>\
                  </div>\
                  <div class="col-lg-6 col-md-6 col-12 pa-0 pr-1 text-right">\
                    <i class="test fas fa-times {iconClass}"></i>\
                  </div>',
    addRowClass: 'row no-gutters pt-1 pb-1 {rowClass}',
  },
  mapManager: {
    versionHistory: {
      warningCheckIn: "Cannot check in, you don't own a lock on the file.",
      okConfirm:
        'Click OK to lock the file for editing. During the check in process, you can release the lock.',
      deleteConfirm: 'Are you sure want to delete?',
      saveSuccess: 'Saved successfully',
      dateValidate: 'Please check Date Period! Maximum period 6 Months',
      userDeleteConfirm: 'Would you like remove this customer?',
      noSelectItem: 'There is no selected item.',
      mapperCheckIn: {
        saveSuccess: 'EDI File has been uploaded successfully',
      },
      scannerCheckIn: {
        saveSuccess: 'EDI File has been uploaded successfully',
      },
    },
    clickBtnDelete: 'There is no selected item',
  },
  flatFileLayout: {
    warningDelete: 'Would you like remove this FlatFile Layout?',
    deleteSuccess: 'Selected item has been deleted successfully.',
    addMapPop: {
      clickBtnSave: "Flatfile Layout, Comment shouldn't be empty",
      clickBtnDelete: 'There is no selected item',
    },
  },
  codetable: {
    clickBtnSave: 'There is no selected code name. Please add the code name first.',
    noSelectItem: 'There is no selected row.',
    deleteConfirm: 'Are you sure you would like to delete the group?',
    warningExistCode: 'This code name has already been added.',
    warningExistCodes: 'These code names have already been added.',
    codeDataPool: {
      saveSuccess: 'Code data has been saved successfully.',
      noData: 'No data has been entered.',
      dup: 'Please check duplicate record.',
      check1000: 'You cannot have more than 1000 record. \nPlease check again.',
      check10000: 'You cannot add new more than 10000 record. \nPlease check again.',
      confirm: 'Some data has changed. Do you want to continue without save them ?',
      checkeWhiteSpace: 'You cannot add white space in the code name.',
    },
  },
  dbBroker: {
    clickBtnSave: 'There is no selected query name. Please add the query name first.',
    noSelectItem: 'There is no selected row.',
    deleteConfirm: 'Are you sure you would like to delete the DB Broker ?',
    warningExistCode: 'This query name has already been added.',
    warningExistCodes: 'These query names have already been added.',
    queryPool: {
      saveSuccess: 'Query data has been saved successfully.',
      noData: 'No data has been entered.',
      dup: 'The same query name is already in use',
      check1000: 'You cannot have more than 1000 record. \nPlease check again.',
      check10000: 'You cannot add new more than 10000 record. \nPlease check again.',
      confirm: 'Some data has changed. Do you want to continue without save them ?',
      qrNmMaxLen: 'Query Name maximum is 30 characters !',
    },
    /*
     * 2021.22.06 203737 SPKA-145 issue 92 DB Broker Development - Add/ Modify Popup Screen
     */

    warningDbNameAndType: 'Only queries with the same DB Name and Type can be added',
    warningAddDbBroker: 'There is no selected query name. Please add the query name first.',
  },
  dbInterfaceConfig: {
    deleteConfirm: 'Are you sure you would like to delete the DB Interface Congfig ?',
  },
  dataSource: {
    deleteConfirm: 'Are you sure you would like to delete the Data Source?',
    sqlGroup: {
      deleteConfirm: 'Are you sure you would like to delete the SQL Group?',
      warningDbType: 'Only queries with the same DB Type can be added',
      warningDbTypeSelect: 'Only queries with the Select Type can be added to Select',
      warningDbTypeEx: 'Queries with the Select Type can not be added to Execution',
      warningAddSQLGroup: 'There is no selected query name. Please add the query name first.',
      warningAddD2DSQLGroup:
        'There is no selected query name in Select and Execution. Please add the query name first.',
      warningValidateD2D: 'Please select SRC/TRG and DB Instance',
    },
  },
  mappingDefinition: {
    clickBtnDelete: 'Please select the items to delete.',
    versionHistory: {
      warningCheckIn: "Cannot check in, you don't own a lock on the file.",
      deleteConfirm: 'Are you sure you would like to delete the mapping definition?',
      saveSuccess: 'Saved successfully',
      clickLinkCheckOut:
        'Click "OK" to lock the file for editing. During the check in process, you can release the lock. Click "Cancel" to check out a read-only copy of the file.',
    },
    mapperCheckIn: {
      saveSuccess: 'File has been uploaded successfully',
    },
  },
  referenceFiles: {
    dateValidate: 'Please check Date Period! Maximum period 6 Months',
    noSelectItem: 'There is no selected item.',
    userDeleteConfirm: 'Are you sure want to delete?',
    deleteSuccess: 'Selected item has been deleted successfully.',
    addReferenceFile: {
      saveSuccess: 'Reference file has been saved successfully',
      warningDialog: 'File Name should not be empty',
    },
  },
  customerDataAnalysis: {
    mergerCompareDataTooltipMsg: 'Please select minimum 2 or maximum 4 items to compare.',
    deleteTooltipMsg: 'Please select the items to delete.',
    createLayoutTooltipMsg: 'Please check the items to create EDI layout.',
    ediAnalyzedViewPop: {
      confirmChangeNewMapper:
        'There is already mapper for this layout. Do you want to change to new mapper?',
    },
  },
  repositoryMatching: {
    mergerCompareRepoMatchingTooltipMsg: 'Please select minimum 2 or maximum 4 items to compare.',
    executeMatchingTooltipMsg:
      'Please select only the "Layout Created" status to execute matching.',
    moveSRMListTooltipMsg:
      'Please select only the "Layout Created"  and "Matching Completed" status to move the items.',
    deleteTooltipMsg: 'Please select the items to delete.',
    statusRollBackTooltipMsg:
      'Please select only the "Layout Created" and "Matching Completed" status to rollback the status.',
  },
  srmListManagement: {
    saveBtn:
      'Multiple rows of the same sender, receiver, and message exist."[sender]", "[receiver]", "[message]"',
    deleteTooltipMsg: 'Please select the items to delete.',
  },
  developmentResourcesManagement: {},
  membership: {},
  company: {
    confirmChangeCompany: 'Would you like to change company?',
    confirmChangeRepoCompany: 'Would you like to change to repository mode?',
    chkCompDup: 'Please check duplicate company e-mail domain.',
  },
  monitoring: {
    reprocessCheck:
      'Current Applied Workflow Version is different from what you try to re-process.\nIt could work unexpectedly.\nIf you do not mind, you can click "OK".',
  },

  partners: {
    saveAdditionalPartner: 'Partner has been added successfully.',
    saveModifyitionalPartner: 'Partner has been modified successfully.',
    deletePartner:
      'Are you sure you would like to delete partner? All registered identification with this partner will be deleted.',
    prnrEmailDup: 'Partner is duplicated.',
    chkprnrDup: 'Please check duplicate partner e-mail domain.',
    dupEDI: 'EDI Identification is duplicate.',
    //deletePartner:'Are you sure you would like to delete the partner?'
  },
  converter: {
    saveAddConverter: 'Converter has been added successfully.',
    saveModifyConverter: 'Converter has been modified successfully.',
    errorSave: 'Save converter has failed.',
  },
  identification: {
    saveAddIdentification: 'Identification has been added successfully.',
    saveModifyIdentification: 'Identification has been modified successfully.',
    deleteIdentification: 'Are you sure you would like to delete the identification?',
    afterDeleteIdentification: 'Removed edi id successfully.',
  },
  communications: {
    seconds: 'Second(s)',
    minutes: 'Minute(s)',
    hours: 'Hour(s)',
    validateInterval: 'Only {0} to {1} {2} are allowed',
    validDuplicatePattern: 'Please check duplicate Put File Name Pattern.',
    validEmptyHttpHeaders: 'Please input HTTP Headers',
    validEmptySoap: 'Please input SOAP',
    validEmptyThead: 'Please input Token Headers',
    validEmptyTConfig: 'Please input Token Config',
    validEmptyHeaders: 'Please input Headers in Callbacks',
    validDuplicate: 'Please check duplicate !',
    validGreaterthan0: 'Value must be greater than 0',
  },
  filter: {
    saveAddFilter: 'Filter has been added successfully.',
    saveModifyFilter: 'Filter has been modified successfully.',
    deleteFilter: 'Are you sure you would like to delete the filter?',
    afterDeleteFilter: 'Removed filter id successfully.',
    checkDuplicate: 'This filter is duplicated',
    errorSave: 'Save filter has failed.',
  },
  aiClient: {
    checkDuplicate: 'This AI Client is duplicated',
    errorSave: 'Save AI Client has failed.',
  },
  /**
   * 06/15/2021 203737 SPKA-141 issue 91 Change notation of file name replacer
   */
  processSetup: {
    checkBoxTooltip: 'Add the Sender ID, Receiver ID and Message to Filename',
    questionIconTooltip:
      'Available values for filename. e.g. ${sender}.${receiver}.${message}.${processId}<br>.${dateTime}.xml <br>-${processId} : Process ID <br>-${dateTime} : Date ‘YYYYMMDDHHMISS’ <br>-${sender} : Sender ID <br>-${receiver} : Receiver ID<br>-${message} : Message Type<br>-${fileName} : File Name<br>-${extension} : Extension',
    addDirComponent: 'Please add Dir component',
    // addDirComponent:'Please add Dir component',
    comInOut: "Connector can't have in, out at the same time",
    ucrInOut: "User Component (UCR) can't have in, out at the same time",
    dsmInOut: "Data Source Management can't have in, out at the same time",
    messageCompany: 'Company can be modified in Workflow',
    rule1: 'Filter only behind Folder.',
    rule2: "Can't connect same Mapper.\nPlease add Folder between them.",
    rule3: "Converter 'Append the SRM to Filename' can't connect to multi Mappers.",
    rule4:
      "Connector / Folder / Data Source / User Component (UCR) can't connect to Corverter & other component at the same time.\nPlease add Folder before each component ( Converter, Mapper, Filter, User Component (UCC) ).",
    rule5:
      "Connector / Data Source / User Component (UCR) can't connect to Mapper & other Connector / Data Source / User Component (UCR) at the same time.\nPlease add Folder before Mapper.",
    ruleEDICheckbox: "Don't add only sender & recipient like as workflow's EDI.",
    dupInfoMap: 'Duplicate sender, recipient, message or EDI version in Mappers.',
    emptySR: 'Please insert sender, recipient.',
    rule6: "Mappers can't connect to Converter 'Append the SRM to Filename'.",
    rule7:
      "Please make link mapper component before select converter 'Append the SRM to File Name'.",
    rule8: 'Please select User Component before connect to it.',
    rule9:
      "Connector / Folder / Data Source / User Component (UCR) can't connect to User Component (UCC) & other component at the same time.\nPlease add Folder before each component ( Converter, Mapper, Filter, User Component (UCC) ).",
    rule10: "Converter/ User Component (UCC) can't have in, out with Mapper at the same time.",
    rule11: 'IF Workflow Group includes Connector, it must be located in DST.',
    rule12: 'Workflow Group must be connected folders in back and forth.',
    ruleTrigger: 'Trigger can be connected with only Connector, User Component, DB Adpater.',
  },
  integrationSET: {},
  repositoryManager: {
    repositoryTab: {
      mergerCompareRepoTooltipMsg:
        'Please select minimum 2 or maximum 4 items in the "Repository Saved" status and same message to compare.',
      saveRepoTooltipMsg: 'Please select the "Customer SRM" status to save to repository.',
      deleteTooltipMsg: 'Please select the items to delete.',
    },
    srmTab: {
      copyRepoTooltipMsg: 'Please select the items not exist in the repository to copy.',
    },
  },
  users: {
    clickIconDelete: 'Are you sure you would like to delete the user?',
    clickBtnSaveAddUser: 'User has been added successfully.',
    clickBtnSaveModifyUser: 'User has been modified successfully.',
    clickBtnSaveMyAccount: 'User information has been saved successfully.',
    questionIconTooltip:
      '8 characters or more : <br>Combination of 3 or more types of English, numeric, and special characters<br>10 characters or more : <br>Combination of 2 or more types of English, numeric, and special characters',
    approveUser: 'Would you like to approve this user?',
  },
  login: {
    expireSession: 'Your session has expired. Please sign in again.',
    validIdPass: 'Login failed due to invalid User Email or Password, please try again.',
    expiredSession:
      'Your token has been expired. Please get a new token through the API and try again.',
    smartLink: 'Data Learning',
    platform: 'Bot',
    signIn: 'Sign In',
    andConnectivity: "and let's get you to the Connectivity!",
    forgotYourPassword: 'Forgot your password?',
    createAccount: 'Request',
    useSmartLink: ' to use SmartLink Platform Account',
    dialogTitleUser: 'User ID is empty',
    dialogTitlePassword: 'Password is empty',
    dialogInfoUser: 'Login user ID is required.',
    dialogInfoPassword: 'Login password is required.',
    validStatusConfirmUser:
      'Your email address is not confirmed yet. Do you want to receive the confirmation email again?',
    validStatusApproveUser: 'Your account is not approved yet.',
    pwdNeverSet:
      'This is your first login. Please reset your password to continue.',
    pwdExpired:
      'Your password has expired (90 days). Please reset your password to continue.',
    otpLocked:
      'Your account has been locked due to too many failed verification attempts. Please contact your administrator.',
  },
  otp: {
    registerTitle: 'Set up 2-step verification',
    registerGuide:
      'Scan the QR code with an authenticator app (Google Authenticator, Microsoft Authenticator, etc.), then enter the 6-digit code shown in the app.',
    cantScan: "Can't scan the QR code?",
    manualKeyGuide: 'Enter this key in your authenticator app:',
    verifyTitle: '2-step verification',
    verifyGuide: 'Enter the 6-digit code from your authenticator app.',
    verify: 'Verify',
    codeRequired: 'Please enter the 6-digit code.',
    restart: 'Please sign in again.',
    error: 'Verification could not be completed. Please sign in again.',
    adminTitle: '2-Step Verification',
    adminManage: 'Reset / Unlock',
    selfResetGuide:
      'To reset your own 2-step verification, enter the current 6-digit code from your authenticator app.',
    selfCode: 'Current 6-digit code',
    selfResetConfirm:
      'Reset your 2-step verification? You will be signed out and must register your authenticator app again at next sign-in.',
    selfResetDone:
      'Your 2-step verification has been reset and you have been signed out. Click Close to sign in again and register your authenticator app.',
    adminNotEnabled: '2-step verification is not enabled.',
    adminRegistered: 'Registered',
    adminNotRegistered: 'Not registered',
    adminLocked: 'Locked',
    adminNotLocked: 'Not locked',
    adminRegDt: 'Registered at',
    adminFailCnt: 'Failed attempts',
    adminReason: 'Reason (required)',
    adminIdentityVerified: "I have verified the user's identity according to the company procedure.",
    adminPassword: 'Your password (re-confirm)',
    adminReset: 'Reset OTP',
    adminUnlock: 'Unlock',
    adminResetConfirm:
      "Reset this user's authenticator registration? The user will be signed out and must register again at next sign-in.",
    adminUnlockConfirm: 'Unlock this user?',
    adminResetDone: '2-step verification has been reset.',
    adminUnlockDone: 'The user has been unlocked.',
    adminMailFailed: 'The notification email could not be sent. Please notify the user directly.',
    adminSessionFailed: "The user's existing sessions could not be terminated. Please check the login user monitoring.",
  },
  codes: {
    saveAddSearchKey: 'Search-Key has been added successfully.',
    saveModifySearchKey: 'Search-Key has been modified successfully.',
    deleteSearchKey: 'Are you sure you would like to delete the Search-Key?',
    afterDeleteSearchKey: 'Removed Search-Key successfully.',
    saveAddMsgCd: 'Message-Code has been added successfully.',
    saveModifyMsgCd: 'Message-Code has been modified successfully.',
    deleteMsgCd: 'Are you sure you would like to delete the Message-Code?',
    afterDeleteMsgCd: 'Removed Message-Code successfully.',
    saveDvrtSiteCd: 'Delivery-Site-Code has been added successfully.',
    saveModifyDvrtSiteCd: 'Delivery-Site-Code has been modified successfully.',
    deleteDvrtSiteCd: 'Are you sure you would like to delete the Delivery-Site-Code?',
    afterDeleteDvrtSiteCd: 'Removed Delivery-Site-Code successfully.',
  },
  clickLogout: 'Are you sure you would like to sign out?',
  workflow: {
    seconds: 'sec',
    minutes: 'min',
    hours: 'hr',
    validateInterval: 'Only {0} to {1} {2}',
  },
  delHistoryWorkflowDialog: {
    messageWarningTop:
      "This component cannot be deleted because it's being used bt the workflows below.",
    messageWarningBottom:
      'This component is being used in the workflow setup above.<br>Do you really want to delete it?',
  },
  systemLog: {
    messageSearchTooltipMsg:
      'Please follow any one of the following conditions. \n1. Date-range should be no longer than a day. \n2. Process ID OR Setup ID search conditon should be used.',
    applyDateConditionTooltipMsg:
      'Please enter Setup ID or Process ID in order to not apply the date condition',
    messageSearchValidation: 'Please check Message Search Conditions again.',
    dateValidate: 'Invalid Date. Please Enter the date within 7 days.',
  },
  xmlMapBuilder: {
    saveTargetQuery: {
      saveSuccess: 'Target Query has been saved successfully.',
    },
    targetQuery: {
      warning: 'Please select one Target Query to open.',
    },
    warningFileNameFormat: 'Only numbers are entered in the file name',
  },
  dbMapperManager: {
    deleteConfirm: 'Are you sure you would like to delete the DB Mapper?',
    deployMapper: {
      deploySuccess: 'DB Mapper has been deployed successfully',
    },
  },
  userSimulator: {
    deployUserComp: {
      deploySuccess: 'User Component has been deployed successfully',
    },
    validDuplicate: 'Please check duplicate !',
  },
  workflowGroup: {
    warningMultipleDST: 'Multiple DST is only allowed when Connector be located at DST',
    warningMultipleSRC: 'Multiple SRC is not allowed',
    warningSRC: 'Communicaiton, DataSourse, Filter, User (UCR) cannot be located at SRC',
    warningDST: 'DataSourse, Filter, User (UCR) cannot be located at DST',
  },
  dbAdapter: {
    deleteConfirm: 'Are you sure you would like to delete the DB Adapter?',
    invalidType: 'Type must be selected.',
    invalidConfig: 'DB Interface Configuration must be saved.',
    validSaveMapper: 'DB Mapper must be saved.',
    invalidMapper: 'DB Mapper validation must be checked.',
    emptyMapper: 'DB Mapper must be loaded.',
    invalidSQL: 'SQL must be loaded.',
    invalidJSON: 'Input JSON must be loaded.',
    invalidExecute: 'You must pass the testing to save.',
    requiredWhereCondition:
      'Origin System, Target System, Interface Module and DB Instance, Where Phrase are required to query.',
    requiredInterfaceToSave: 'Interface Control Table are required to save.',
    requiredInterfaceCondition:
      'Origin System, Target System, Interface Module and DB Instance, Interface Control Table are required to query.',
    invalidTestResult: 'Invalid test result!',
    check100: 'You cannot have more than 100 record. \nPlease check again.',
  },
};
